// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils__DictPlus from "../dictPlus/Utils__DictPlus.bs.js";

function addEntries(json, entries) {
  return Utils__DictPlus.addEntries(Core__Option.getOr(Core__JSON.Decode.object(json), {}), entries);
}

function fromArray(entries) {
  return Object.fromEntries(entries);
}

export {
  addEntries ,
  fromArray ,
}
/* No side effect */
